/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React,{useRef,useState} from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18next from "i18next";
import {HOST_SERVER,LOGIN_ENVIRONMENT,IDLE_TIMEOUT_HOURS,activityEvents,TIMEOUT_LOGOUT} from '../utils/configs';
import { capitalizeFirstLetter,storageUtil,logoutTimeOutLabel } from '../utils/commonFunctions';
import { languages } from '../utils/languages';
import { ImKey } from "react-icons/im";
import { APIEndpoint } from '../utils/axios';
import { FiAlertTriangle } from "react-icons/fi";
import closeIcon from '../images/icons/Icon2.png';
import PasswordValidator from '../common/PasswordValidation';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { themesList, setTheme, DEFAULT_THEME_INDEX } from '../utils/themes';
import UserSession from '../utils/userSessionClass';
import { getCurrentMenuItem } from "./SidebarComponent";
/**
 * Icons
 */
import enlang from '../assets/enlang.svg';
import frnlang from '../assets/france.svg';
import spainlang from '../assets/spainlang.svg';
import uaelang from '../assets/uaelang.svg';
import locationSvg from '../assets/icons/svg/location-icon.svg';
import themeSvg from '../assets/icons/svg/theme-icon.svg';
import signOutSvg from '../assets/icons/svg/signout-icon.svg';


export const TopHeaderComponent = (props) => {
  const { t,ready } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
   const inactivityTimerRef = useRef(null);
   const inactivityInvokeTime = useRef(0);
   const throttleDelay=1000;
  const userSession = new UserSession();
  const [logoutWait, setLogoutWait] = React.useState(TIMEOUT_LOGOUT||180);
  const sessionVals = userSession.getSessionValues();
  const currentLanguageCode = i18next.language || 'en'
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
  const [themeClassObj, setThemeClassObj] = React.useState(themesList[DEFAULT_THEME_INDEX]);
  const [showDropdown, setShowDropdown] = React.useState(false);
  const [logoutPrompt,setLogoutPrompt]= React.useState(false);
  const [logoSite, setLogoSite] = React.useState("");
  const [loginMode, setLoginMode] = React.useState("");
  const [showPasswordChange, setShowPasswordChange] = React.useState(false);
  const [loginMessage, setLoginMessage] = useState({text:""})
  const [updatePassword,setUpdatePassword]=useState({currentPassword:"",newPassword:"",confirmPassword:""});
  const [validatePasswordUpdate,setValidatePasswordUpdate]=useState(true);
  const [passwordMatch,setPasswordMatch]=useState(false);
  const [disabledFields,setDisabledFields]=useState(false);
  const [showPass, setshowPass] = useState({ default: false, currentPassword: false, newPassword: false, confirmPassword: false });
  const clearMsgTimer = useRef(null);




  const logoImg=`${HOST_SERVER}/assets/images/public/company-logo.png`;
const locationMap = JSON.parse(localStorage.getItem('NGO_CULTURE'))?.timezone?.name??"";
  let heading = location.state;
  if (!heading) {
    heading = getCurrentMenuItem(location);
  }

    const startInactivityTimer = (e) => {
      const currTime=Date.now();
if(currTime-inactivityInvokeTime.current >= throttleDelay){
  inactivityInvokeTime.current=currTime;
    if (inactivityTimerRef.current) {
      clearTimeout(inactivityTimerRef.current);
    }

    inactivityTimerRef.current = setTimeout(() => {
     setLogoutPrompt(true);
    }, IDLE_TIMEOUT_HOURS) 
}

 
  };

React.useEffect(() => {
  if (logoutPrompt) {
    if (logoutWait === 0) {
      setLogoutPrompt(false);
      logoutTimeCheck();
      return;
    }
 
    const intervalId = setInterval(() => {
      setLogoutWait((prev) => prev - 1);
    }, throttleDelay);

    return () => clearInterval(intervalId);
  }
}, [logoutWait, logoutPrompt]);


  React.useEffect(() => {
    document.body.dir = currentLanguage.dir || 'ltr'
  }, [currentLanguage, t]);



  const setUserTheme = (theme = themesList[0]) => {
    setThemeClassObj(theme);
    setTheme(theme);
  };



  React.useEffect(() => {
    let theme = themeClassObj;
    if (storageUtil.get('theme','local') && typeof storageUtil.get('theme','local') === 'object') {
      theme = storageUtil.get('theme','local');
    }
    if(storageUtil.get('sType','local')){
      setLoginMode(storageUtil.get('sType','local'));
    }
    setUserTheme(theme);
    checkLogoUrl();
    startInactivityTimer(); 
    activityEvents.forEach(event => 
      window.addEventListener(event, startInactivityTimer)
    );

    return () => {
      activityEvents.forEach(event => 
        window.removeEventListener(event, startInactivityTimer)
      );
      if (inactivityTimerRef.current) {
        clearTimeout(inactivityTimerRef.current);
      }
    };
  }, []);

  React.useEffect(() => {
    /**
     * Set title
     */
    if (heading && heading?.title && ready) {
      document.title = t(`company.productName`) + ' ' + t(`pages.${heading.title.key}`);

      if (heading.subTitle) {
        document.title += ' - ' + t(`pages.${heading.title.key}Sub.${heading.subTitle.key}`);

        if (heading.subMenuItem2) {
          document.title += ' - ' + t(`pages.${heading.title.key}Sub.${heading.subTitle.key}Sub.${heading.subMenuItem2.key}`);
        }
      }

    }
    else {
      document.title = 'nGO Pro';
    }

  }, [ready, heading]);

  React.useEffect(() => {
    /**
     * Auto hide dropdown menu if open after some time
     */
    if (showDropdown) {
      setTimeout(() => {
        setShowDropdown(false);
      }, 10000);
    }
  }, [showDropdown]);

const checkLogoUrl=async()=>{
    try {
      const imgUrl = await APIEndpoint.get(logoImg);
    if(imgUrl && !logoSite?.length){
      setLogoSite(logoImg)
    }
    } catch (error) {


    }
}


  const getMonthLangFormat=(sessionVals)=>{
    const {login_date}=sessionVals;
    let month = "",
     num = "",
     loginDate=""
    for (let i=0; i<login_date.length; i++)
    {
        if (!isNaN(String(login_date[i]) * 1))
            num+=login_date[i];
        if((login_date[i] >= 'A' && login_date[i] <= 'Z') ||
         (login_date[i] >= 'a' && login_date[i] <= 'z'))
            month+=login_date[i];
    }

    switch (month) {
      case 'January':
        loginDate= `${num.substring(0, 2)}  ${t('months.jan')}  ${num.substring(num.length - 4)}`
        break;
        case 'February':
       loginDate= `${num.substring(0, 2)}  ${t('months.feb')}  ${num.substring(num.length - 4)}`
        break;
        case 'March':
        loginDate= `${num.substring(0, 2)}  ${t('months.mar')}  ${num.substring(num.length - 4)}`
         break;
         case 'April':
         loginDate= `${num.substring(0, 2)}  ${t('months.apr')}  ${num.substring(num.length - 4)}`
          break;
          case 'May':
          loginDate= `${num.substring(0, 2)}  ${t('months.may')}  ${num.substring(num.length - 4)}`
           break;
           case 'June':
           loginDate= `${num.substring(0, 2)}  ${t('months.june')}  ${num.substring(num.length - 4)}`
            break;
            case 'July':
            loginDate= `${num.substring(0, 2)}  ${t('months.july')}  ${num.substring(num.length - 4)}`
             break;
             case 'August':
             loginDate= `${num.substring(0, 2)}  ${t('months.aug')}  ${num.substring(num.length - 4)}`
              break;
              case 'September':
              loginDate= `${num.substring(0, 2)}  ${t('months.sep')}  ${num.substring(num.length - 4)}`
               break;
               case 'October':
               loginDate= `${num.substring(0, 2)}  ${t('months.oct')}  ${num.substring(num.length - 4)}`
                break;
                case 'November':
                loginDate= `${num.substring(0, 2)}  ${t('months.nov')}  ${num.substring(num.length - 4)}`
                 break;
                 case 'December':
                 loginDate= `${num.substring(0, 2)}  ${t('months.dec')}  ${num.substring(num.length - 4)}`
                  break;
      default:
        break;
    }
    return loginDate;
  }

  React.useEffect(() => {
    if (!sessionVals.token) {
      navigate('/login');
      return <></>;
    }

    if (sessionVals.login_date) {
      getMonthLangFormat(sessionVals)
    }
  }, [sessionVals,t]);


  const toggleShowDropdown = () => {
    setShowDropdown(!showDropdown);
  }

  function logoutTimeCheck(){
    signOutHandler();
    window.location.reload();
  }

  const signOutHandler = () => {
    // Clear session data
    storageUtil.clear('sType','local')
    storageUtil.clear('pageStateSynced','session')
    storageUtil.clear('pageState','session')
    storageUtil.clear('pageFiltersFinalized','session')
    storageUtil.clear('','local');
    userSession.destroySession();
    navigate('/login');
  };
const settingsMenu=()=>{
setShowPasswordChange(true);
}
  const getCountryFlags=(langCode)=>{

    let langImage;

    switch (langCode) {
      case 'sp':
        langImage = <img className="icon-lang" alt='spanish' src={spainlang} />;
        break;
      case 'en':
        langImage = <img className="icon-lang" alt='english' src={enlang} />;
        break;
      case 'fr':
        langImage = <img className="icon-lang" alt='french' src={frnlang} />;
        break;
      case 'ar':
        langImage = <img className="icon-lang" alt='arabic' src={uaelang} />;
        break;
      default:

        langImage = <img className="icon-lang" alt='english' src={enlang} />;
        break;
    }

    return langImage;

  }
const onChangePassword=async()=>{
      setDisabledFields(true);
      let body ={
        currentPassword: updatePassword.currentPassword,
        newPassword:  updatePassword.newPassword,
        confirmPassword: updatePassword.confirmPassword,
        isValidPassword: true
    };
    
      try {
        const userResp = await APIEndpoint.post('employee/updateLoginPassword', body);
        if(userResp){
          const msg = userResp?.message ?? "Password updated successfully. Please login with new password.";
          setLoginMessage({text:msg});
          resetMessages(2500);
        }
      } catch (error) {
        console.error('Login error:', error);
        let erMsg = 'Update Password Error!';
        try {
          let parsedError = JSON.parse(error.message);
          erMsg = parsedError?.data?.msg || parsedError?.data?.message || erMsg;
        } catch (_) {}
        setLoginMessage({error:erMsg});
        resetMessages(3500);
      } finally {
      
      }
}
function onClose(){
setShowPasswordChange(false);
setLoginMessage({text:''});
setDisabledFields(false);
setUpdatePassword({currentPassword:"",newPassword:"",confirmPassword:""});
}
 function resetMessages(tOut=3500){
  if(clearMsgTimer.current){
    clearTimeout(clearMsgTimer.current);
  }
  clearMsgTimer.current= setTimeout(()=>{
setLoginMessage({text:''});
setDisabledFields(false);
setUpdatePassword({currentPassword:"",newPassword:"",confirmPassword:""});
  },tOut)
  return clearMsgTimer.current;
}
function handleBlockEvent(e){
  e.preventDefault();
}
  return (
    <>
 <div className='top-header-container width100 flexRow justifyContentFlexStart alignItemsCenter'>
        <div className='flexRow logo-block alignItemsCenter'>
          <button className='btn-close' onClick={props.onMenu}>
            <i className='icon-menu' />
          </button>
          {loginMode && <img src={logoSite} alt="logo" onClick={() => navigate('/dashboard')} className='logo' /> }
        </div>
        <div className='flexRow full-flex justifyContentSpaceBetween alignItemsCenter breadcrumb-row'>
           <div className='flexRow justifyContentFlexStart'><span className="login-label-logo justifyContentCenter alignItemsCenter">{LOGIN_ENVIRONMENT}</span></div>
          <div className="top-header-menu ">
            <div className='menu-container'onClick={() => toggleShowDropdown()} >
              <div className="dropdown-pic-block" >{sessionVals?.employeeName!=="null"?sessionVals?.employeeName?.charAt(0).toUpperCase():sessionVals?.username?.slice(0,2).toUpperCase()}</div>
              <div className={`dropdown-content-block${currentLanguageCode==='ar' ? '-arabic' : ""}`} style={{ display: showDropdown ? 'block' : 'none' }} onMouseLeave={()=>toggleShowDropdown()}>
                <div className="menu-item">
                  <span ><img src={locationSvg} alt="" className='menuitemicon' /> {locationMap}</span>
                </div>
                <div className="menu-item">
                  <img src={themeSvg} alt="" className='menuitemicon' /> <button
                    className="btn btn-link dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton2"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {t(`themeNames.${themeClassObj?.title}`)}
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                    {themesList.map((row, index) => (
                      <li key={index} onClick={() => {
                        setUserTheme(row)
                      }}>
                        <h6 className="dropdown-item">
                          {capitalizeFirstLetter( t(`themeNames.${row.title}`) )}
                        </h6>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="menu-item">
                  <button
                    className="btn btn-link dropdown-toggle unset-width"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {getCountryFlags(currentLanguage.country_code)} &nbsp;
                    {t(`languageNames.${currentLanguage.country_code}`)}
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                    {languages.map(({ code, name, country_code }) =>
                    (
                      <li key={country_code}
                        onClick={() => {
                          i18next.changeLanguage(code)
                        }}>
                       <h6 className={currentLanguage.country_code!==code?"dropdown-item":"dropdown-item body-text-extrabold"} >
                           <span className='flexRow alignItemsCenter'>{getCountryFlags(code)}&nbsp;&nbsp;{t(`languageNames.${code}`)}</span>
                        </h6>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="menu-item" onClick={settingsMenu}>
                  <span ><ImKey /> &nbsp;{t('topHeader.settings')}</span>
                </div>
                    <div className="menu-item" onClick={signOutHandler}>
                  <span ><img src={signOutSvg} alt="" className='menuitemicon' /> {t('topHeader.signout')}</span>
                </div>

               
                <div className="menu-text">
                  <span>{sessionVals.login_time ? getMonthLangFormat(sessionVals) : ''}<br />
                  {t('topHeader.loginAtText')} {sessionVals.login_time}</span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      
      {
      logoutPrompt && 
      <div className='overlay-logout' role="dialog">
         <div className="dialog2 sm-scrollbar">                           
                                <div className="dialog__header pt-4">
                                   <div className='flexRow justifyContentCenter'><FiAlertTriangle color='#D7A31A' size='25' style={{ marginRight: '10px' }} /> <h2 className="dialog__title subheading-text-medium fontMedium">{"Your session is about to expire"}</h2></div>
                                </div>
        
                                <div className="dialog__content mt-0">
                                    <div className="dialog__body_container flexRow justifyContentSpaceBetween flexWrap">
        
                                        <div className="flexCol justifyContentSpaceEvenly">
                                            <div className="dialog__container_item">
                                               <div style={{color:'#ffffff'}} className="margTop40 subheading-text-semibold">
                                                <><p>{`You will be logged out in ${logoutTimeOutLabel(logoutWait)}`}</p></>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                
                                </div>
                                    
                                <div className="dialog__footer flexRow justifyContentSpaceEvenly pt-2 mb-4">
                                    <button type="button" className="cancel-button" onClick={logoutTimeCheck}>{'Logout'}</button>
                                    <button type="submit" className="done-button" onClick={()=>{
                                       setLogoutPrompt(false);
                                       setLogoutWait(TIMEOUT_LOGOUT);
                                      startInactivityTimer()}}>{'Continue Session'}</button>
                                </div>
                           
                        </div>
      </div>
      }

      {
             showPasswordChange ?  <div className="overlay_hide sub" role="dialog">
      <div className="dialog" style={{margin:'10px 0px'}}>
        <div className="dialog__content margTop24">
            <img className="modal__close_icon" alt='Close' src={closeIcon} onClick={onClose} />
            <h2 className="dialog__title subheading-text-medium fontMedium">Change Password</h2>
            <hr style={{color:'#fff'}}/>
             {Object.keys(updatePassword).length>0?<PasswordValidator passwordMatchError={setPasswordMatch} showValidation={validatePasswordUpdate} empPassword={true} isValidPassword={setValidatePasswordUpdate} passwordFields={updatePassword}/>:null}
    <div className="dialog__body_container flexRow justifyContentCenter alignItemsCenter flexWrap">
    <div className="dialog__container_item input-container">
                <div style={{color:'#ffff'}} className="dialog__description margBtm15">
            <label className='req fontRegular margTop16'>{t('pages.loginContent.currentPassword')}</label>
            <div className='password-input-container'>
              <input
                onChange={e =>setUpdatePassword((_)=>({..._,currentPassword:e.target.value}))}
                type={showPass.currentPassword ? "text":"password"}
                value={updatePassword.currentPassword}
                  onCopy={handleBlockEvent}
                  onPaste={handleBlockEvent}
                  onCut={handleBlockEvent}
                disabled={disabledFields}
                className='edit-input'
              />
              <span
            onClick={() => setshowPass(prev => ({ ...prev, currentPassword: !prev.currentPassword }))}
            className="eye-toggle"
          >
            {!showPass.currentPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
                    
    </div>

            </div>
            </div>
 </div>

    <div className="dialog__body_container flexRow justifyContentCenter flexWrap">
    <div className="dialog__container_item input-container">
                   <div style={{color:'#ffff'}} className="flexCol justifyContentCenter alignItemsCenter dialog__description margBtm15">
                     <div style={{paddingBottom:'10px'}}>
          <label className='flexRow textAlignLeft req fontRegular margTop16'>{t('pages.loginContent.newPassword')}</label>    
           <div className='password-input-container'>
            
              <input
                onChange={e => setUpdatePassword((_)=>({..._,newPassword:e.target.value}))}
                type={showPass.newPassword ? "text":"password"}
                value={updatePassword.newPassword}
                disabled={disabledFields}
                 onCopy={handleBlockEvent}
                  onPaste={handleBlockEvent}
                  onCut={handleBlockEvent}
                className='edit-input'
              />
              <span
            onClick={() => setshowPass(prev => ({ ...prev, newPassword: !prev.newPassword }))}
            className="eye-toggle"
          >
            {!showPass.newPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
            </div>    
                     </div>
              {passwordMatch?<h6 className="small-body-text-regular-label-upload text-danger">{t('warningTexts.passwordMatchUpdate')}</h6>:<></>}
                </div>
                </div>
                </div>
              
   <div className="dialog__body_container flexRow justifyContentCenter alignItemsCenter flexWrap">
    <div className="dialog__container_item input-container">
                <div style={{color:'#ffff'}} className="flexCol justifyContentCenter alignItemsCenter dialog__description">
                  <div style={{paddingBottom:'10px'}}>
              <label className='flexRow textAlignLeft req fontRegular margTop16'>{t('pages.loginContent.confirmPassword')}</label>
               <div className='password-input-container'>
              <input
                onChange={e => setUpdatePassword((_)=>({..._,confirmPassword:e.target.value}))}
                type={showPass.confirmPassword ? "text":"password"}
                value={updatePassword.confirmPassword}
                  disabled={disabledFields}
                   onCopy={handleBlockEvent}
                  onPaste={handleBlockEvent}
                  onCut={handleBlockEvent}
                className='edit-input'
              />
              <span
            onClick={() => setshowPass(prev => ({ ...prev, confirmPassword: !prev.confirmPassword }))}
            className="eye-toggle"
          >
            {!showPass.confirmPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
               </div>
                  </div>
              {passwordMatch?<h6 className="small-body-text-regular-label-upload text-danger">{t('warningTexts.passwordMatchUpdate')}</h6>:<></>}
                </div>
                </div>
                </div>
                {(loginMessage.text?.length || loginMessage.error?.length) ? (
            <div style={{padding:'0.2rem',marginBottom:'8px'}} className={"dialog__statusBlock " + (loginMessage && loginMessage?.error?.length ? 'alert_error':'alert_success')}>
            <h6 className="subheading-text-medium-title fontLight">
              {loginMessage.text || loginMessage.error}
            </h6>
            </div>
          ) : null}
               <div className="dialog__footer flexCol alignItemsCenter">
                       <button disabled={validatePasswordUpdate||disabledFields} className={"done-button"}  onClick={onChangePassword}>{"Update Password"}</button>
                 </div>

          </div>
      
        </div>
                     

          

  </div>:null
      }
      {
      !ready &&<div className='overlay_hide sub'></div>
      }
    </>);
}